import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const BookLibraryIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g className="nc-icon-wrapper">
      <path d="M2.367 24a2.252 2.252 0 0 1-2.25-2.25V7.5a2.252 2.252 0 0 1 2.25-2.25h2.018a.75.75 0 0 1 0 1.5H2.367a.75.75 0 0 0-.75.75v14.25c0 .414.336.75.75.75h2.018a.75.75 0 0 1 0 1.5H2.367z" />
      <path d="M8.367 24a2.252 2.252 0 0 1-2.25-2.25V2.25c0-1.241 1.01-2.25 2.25-2.25h3a2.252 2.252 0 0 1 2.25 2.25v1.684l1.353-.514a2.23 2.23 0 0 1 .798-.147c.929 0 1.775.583 2.105 1.45l5.866 15.422a2.233 2.233 0 0 1-.051 1.721 2.237 2.237 0 0 1-1.253 1.182l-1.402.533a2.246 2.246 0 0 1-2.904-1.303l-4.513-11.866V21.75a2.252 2.252 0 0 1-2.25 2.25H8.367zm0-22.5a.75.75 0 0 0-.75.75v19.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75V2.25a.75.75 0 0 0-.75-.75h-3zm7.402 3.272a.737.737 0 0 0-.266.049l-1.402.533c-.187.071-.335.211-.417.394s-.088.386-.017.574l5.866 15.422a.743.743 0 0 0 .701.483c.091 0 .18-.017.266-.05l1.403-.533a.747.747 0 0 0 .435-.968l-5.867-15.42a.755.755 0 0 0-.702-.484z" />
      <path d="M9.867 16.5a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 1.5 0v12a.75.75 0 0 1-.75.75z" />
      <circle cx="9.867" cy="19.5" r="1.125" />
    </g>
  </Icon>
);

export default BookLibraryIcon;
